import { SET_PREVIEW, TOGGLE_PREVIEW } from "../../../actions/previewActions";

const initialState = {
    isEnabled: false
};

export const previewReducer = (state = initialState, action) => {

    switch (action.type) {
        case TOGGLE_PREVIEW:
            return {
                ...state,
                isEnabled: !state.isEnabled
            };
        case SET_PREVIEW:
            return {
                ...state,
                isEnabled: action.payload
            };
        default:
            return state;
    }
};